
// 封装接口后台封装调用

import axios from '../utils/axios'

//设置个对象，就不用一个个暴露了，直接暴露对象
let serverApi = {};

/* 获取列表 */
//查询列表，详情就是get
/* /api/getlist是请求接口地址，有http.js里面的Ip加上，如：http:192.168.0.1:9090//api/getlist  */
// apiFun.getlist = function(params) {
let api = 'api/'
// let api = '' // 当前线上
//let baiduyun = 'baiduyun/'
let pay = 'pay/'
serverApi.findHisOrderListP = function(params) {
  return axios.post(api+'api/cmp.his.Order_read_lz/findListP', params)
}
serverApi.findProductList = function(params) {
  return axios.post(api+'api/cmp.his.Product_read_lz/findList', params)
}
serverApi.findWarehouseProductSellSum = function(params) {
  return axios.post(api+'api/cmp.his.Warehouse_product_read_lz/sumProduct', params)
}
serverApi.findWarehouseProductSellList = function(params) {
  return axios.post(api+'api/cmp.his.Warehouse_product_read_lz/findProductSellList', params)
}
serverApi.findHisOrderServiceListP = function(params) {
  return axios.post(api+'api/cmp.his.Order_read_lz/findServerListP', params)
}
serverApi.findHisOrderSellListP = function(params) {
  return axios.post(api+'api/cmp.his.Order_read_lz/findSellListP', params)
}
serverApi.findPurchaseListP = function(params) {
  return axios.post(api+'api/cmp.his.Warehouse_in_purchase_read_lz/findListP', params)
}
serverApi.findWithdrawProxyListP = function(params) {
  return axios.post(api+'api/cmp.shop.Withdraw_proxy_read_lz/findListP', params)
}

serverApi.findWarehouseProductListP = function(params) {
  return axios.post(api+'api/cmp.his.Warehouse_product_read_lz/findListP', params)
}
serverApi.findWarehouseProductSum = function(params) {
  return axios.post(api+'api/cmp.his.Warehouse_product_read_lz/sumProduct', params)
}

serverApi.findShopPayNextQrcode = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_pay_lz/getNextQrcode', params)
}
serverApi.findShopPayListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_pay_read_lz/findListP', params)
}
serverApi.findShopBindThirdListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_bind_third_read_lz/findListP', params)
}
serverApi.shopBindThirdSave = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_bind_third_read_lz/save', params)
}

serverApi.shopBalanceParamsSave = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_balance_params_read_lz/save', params)
}
serverApi.findShopBalanceParamsByShopList = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_balance_params_read_lz/findByShopList', params)
}
serverApi.ShopBalanceSetSaveAll = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_balance_set_read_lz/saveAll', params)
}
serverApi.ShopBalanceSetUpdate = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_balance_set_read_lz/update', params)
}
serverApi.deleteShopBalanceSet = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_balance_set_read_lz/del', params)
}
serverApi.ShopBalanceSetSave = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_balance_set_read_lz/save', params)
}
serverApi.findShopBalanceSetListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_balance_set_read_lz/findListP', params)
}
serverApi.findBankList = function(params) {
  return axios.post(api+'api/cmp.sys.Bank_read_lz/findList', params)
}

serverApi.shopBankSave = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_bank_lz/save', params)
}

serverApi.findShopBalanceParamsListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_balance_params_read_lz/findListP', params)
}
serverApi.paySourceParamsSave = function(params) {
  return axios.post(api+'api/cmp.shop.Pay_source_params_lz/save', params)
}
serverApi.paySourceParamsUpdate = function(params) {
  return axios.post(api+'api/cmp.shop.Pay_source_params_lz/update', params)
}
serverApi.findShopPaySourceParamsListP = function(params) {
  return axios.post(api+'api/cmp.shop.Pay_source_params_read_lz/findListP', params)
}


serverApi.carLineSave = function(params) {
  return axios.post(api+'api/cmp.shop.Car_line_lz/save', params)
}
serverApi.carLineListP = function(params) {
  return axios.post(api+'api/cmp.shop.Car_line_read_lz/findByLgsListP', params)
}

serverApi.oilProductListP = function(params) {
  return axios.post(api+'api/cmp.his.Oil_product_read_lz/findListP', params)
}
serverApi.carinfoOwnerLgsListP = function(params) {
  return axios.post(api+'api/cmp.car.Car_info_lgs_owner_read_lz/findListP', params)
}

serverApi.ownerLgsListP = function(params) {
  return axios.post(api+'api/cmp.car.Owner_lgs_read_lz/findListP', params)
}

serverApi.orderOilListP = function(params) {
  return axios.post(api+'api/cmp.car.Order_oil_read_lz/findListP', params)
}

serverApi.carinfoSaveOne = function(params) {
  return axios.post(api+'api/cmp.car.Car_info_lz/saveOne', params)
}
serverApi.findCarOne = function(params) {
  return axios.post(api+'api/cmp.car.Car_info_read_lz/findOne', params)
}
serverApi.findCarListP = function(params) {
  return axios.post(api+'api/cmp.car.Car_info_read_lz/findListP', params)
}
serverApi.findCarPitchListP = function(params) {
  return axios.post(api+'api/cmp.car.Car_pitch_read_lz/findListP', params)
}

serverApi.findCarYearList = function(params) {
  return axios.post(api+'api/cmp.car.Car_year_read_lz/findList', params)
}

serverApi.carStyleSave = function(params) {
  return axios.post(api+'api/cmp.car.Car_style_lz/save', params)
}

serverApi.findCarStyleTree = function(params) {
  return axios.post(api+'api/cmp.car.Car_style_read_lz/findTree', params)
}
serverApi.findCarStyleTable = function(params) {
  return axios.post(api+'api/cmp.car.Car_style_read_lz/findTable', params)
}
serverApi.findPitchTable = function(params) {
  return axios.post(api+'api/cmp.car.Car_pitch_read_lz/findTable', params)
}

serverApi.findPayIcbcListP = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_icbc_lz/findListP', params)
}
serverApi.findPayYbListP = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_yb_lz/findListP', params)
}
serverApi.findPaySftListP = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_sft_lz/findListP', params)
}

serverApi.shopYhcListP = function(params) {
  return axios.post(api+'api/cmp.pay.Yhc_read_lz/findListP', params)
}

serverApi.posMemberListP = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_member_lz/findListP', params)
}
serverApi.findProdcutListP = function(params) {
  return axios.post(api+'api/cmp.his.Product_read_lz/findListP', params)
}
serverApi.findProdcutOne= function(params) {
  return axios.post(api+'api/cmp.his.Product_read_lz/findOne', params)
}
serverApi.hisProductCategoryTree = function(params) {
  return axios.post(api+'api/cmp.his.Product_category_read_lz/findTree', params)
}

serverApi.hisProductCategorySave= function(params) {
  return axios.post(api+'api/cmp.his.Product_category_lz/save', params)
}

serverApi.findDemandUserRegionListP = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_user_region_read_lz/findListP', params)
}
serverApi.findDemandUserKeywordListP = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_user_keyword_read_lz/findListP', params)
}
serverApi.findDemandListP = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_read_lz/findListP', params)
}
serverApi.demandSave = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_lz/save', params)
}
serverApi.demandDel = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_lz/del', params)
}
serverApi.demandDeal = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_lz/deal', params)
}

serverApi.demandCategorySave = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_category_lz/save', params)
}
serverApi.demandCategoryTable = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_category_read_lz/findTable', params)
}

serverApi.demandCategoryTree = function(params) {
  return axios.post(api+'api/cmp.mall.Demand_category_read_lz/findTree', params)
}

serverApi.uploadForeignListP = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_foreign_read_lz/findListP', params)
}

serverApi.findUploadCategoryTree= function(params) {
  return axios.post(api+'api/cmp.sys.Upload_category_read_lz/findTree', params)
}

serverApi.eduClueListP = function(params) {
  return axios.post(api+'api/cmp.edu.Clue_read_lz/findListP', params)
}
serverApi.lsRegister = function(params) {
  return axios.post(api+'api/cmp.pay.Leshua_register_lz/register', params)
}

serverApi.classesStudentSave = function(params) {
  return axios.post(api+'api/cmp.edu.Classes_student_lz/save', params)
}
serverApi.classesStudentList = function(params) {
  return axios.post(api+'api/cmp.edu.Classes_student_read_lz/findList', params)
}
serverApi.classesListP = function(params) {
  return axios.post(api+'api/cmp.edu.Classes_read_lz/findListP', params)
}
serverApi.classesList = function(params) {
  return axios.post(api+'api/cmp.edu.Classes_read_lz/findList', params)
}

serverApi.eduStudentEnrollSave = function(params) {
  return axios.post(api+'api/cmp.edu.Student_lz/enroll', params)
}
serverApi.eduConsultSave = function(params) {
  return axios.post(api+'api/cmp.edu.Consult_lz/save', params)
}
serverApi.consultListP = function(params) {
  return axios.post(api+'api/cmp.edu.Consult_read_lz/findListP', params)
}
serverApi.goodsCategorySave = function(params) {
  return axios.post(api+'/api/cmp.mall.Gcategory_lz/save', params)
}
serverApi.timetableStudentSignListP = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_student_sign_read_lz/findListP', params)
}
serverApi.timetableStudentSignSave = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_student_sign_lz/save', params)
}
serverApi.studentOne = function(params) {
  return axios.post(api+'api/cmp.edu.Student_read_lz/findOne', params)
}
serverApi.studentSave = function(params) {
  return axios.post(api+'api/cmp.edu.Student_lz/save', params)
}
serverApi.payLogSave = function(params) {
  return axios.post(api+'api/cmp.edu.Student_lz/payLogSave', params)
}
serverApi.payLogList = function(params) {
  return axios.post(api+'api/cmp.edu.Pay_log_read_lz/findList', params)
}
serverApi.studentListP = function(params) {
  return axios.post(api+'api/cmp.edu.Student_read_lz/findListP', params)
}
serverApi.studentList = function(params) {
  return axios.post(api+'api/cmp.edu.Student_read_lz/findList', params)
}

serverApi.subjectList = function(params) {
  return axios.post(api+'api/cmp.edu.Subject_read_lz/findList', params)
}

serverApi.timetableList = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_read_lz/findList', params)
}
serverApi.timetableSave = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_lz/save', params)
}
serverApi.timetableStudentSave = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_student_lz/save', params)
}
serverApi.timetableStudentList = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_student_read_lz/findList', params)
}
serverApi.timetableStudentListP = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_student_read_lz/findListP', params)
}
serverApi.timetableListP = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_read_lz/findListP', params)
}
serverApi.timetableDetailOne = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_detail_read_lz/findOne', params)
}
serverApi.timetableOne = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_read_lz/findOne', params)
}
serverApi.timetableDetailListP = function(params) {
  return axios.post(api+'api/cmp.edu.Timetable_detail_read_lz/findListP', params)
}
serverApi.teacherSave = function(params) {
  return axios.post(api+'api/cmp.edu.Teacher_lz/save', params)
}
serverApi.schoolSave = function(params) {
  return axios.post(api+'api/cmp.edu.School_lz/save', params)
}
serverApi.schoolOne = function(params) {
  return axios.post(api+'api/cmp.edu.School_read_lz/findOne', params)
}
serverApi.schoolListP = function(params) {
  return axios.post(api+'api/cmp.edu.School_read_lz/findListP', params)
}
serverApi.schoolList = function(params) {
  return axios.post(api+'api/cmp.edu.School_read_lz/findList', params)
}
serverApi.schoolOne = function(params) {
  return axios.post(api+'api/cmp.edu.School_read_lz/findOne', params)
}
serverApi.teacherOne = function(params) {
  return axios.post(api+'api/cmp.edu.teacher_read_lz/findOne', params)
}
serverApi.teacherListP = function(params) {
  return axios.post(api+'api/cmp.edu.teacher_read_lz/findListP', params)
}
serverApi.teacherList = function(params) {
  return axios.post(api+'api/cmp.edu.teacher_read_lz/findList', params)
}

serverApi.posMemberTerminalListP = function(params) {
  return axios.post(api+'api/cmp.proxy.Pos_member_terminal_read_lz/findListP', params)
}


serverApi.proxyDepartmentDel = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_department_lz/del', params)
}
serverApi.proxyDepartmentSave = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_department_lz/save', params)
}
serverApi.proxyDepartmentTree = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_department_read_lz/findChildrenList', params)
}


// 添加员工
serverApi.proxyEmployeeDel = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_employee_lz/delReal', params)
}
serverApi.proxyEmployeeSave = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_employee_lz/saveNormal', params)
}
serverApi.proxyEmployeeOne = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_employee_read_lz/findOne', params)
}

serverApi.proxyEmployeeListP = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_employee_read_lz/findListP', params)
}
// 角色管理--设置权限
serverApi.proxyRoleSetPower = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_role_lz/setPower', params)
}
serverApi.proxyRoleModuleList = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_module_read_lz/findModuleIdsList', params)
}

serverApi.proxyRoleDelModule = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_role_lz/delModule', params)
}
serverApi.companyRoleDelModule = function(params) {
  return axios.post(api+'api/cmp.sys.Company_role_lz/delModule', params)
}


// 菜单列表
serverApi.proxyModuleFindTree = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_module_read_lz/findTree', params)
}

// 角色添加
serverApi.proxyRoleSave = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_role_lz/save', params)
}

serverApi.proxyUserChangePsw = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_user_lz/changePassword', params)
}
serverApi.proxyUserUpdate = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_user_lz/update', params)
}
serverApi.proxyUserSave = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_user_lz/save', params)
}

serverApi.proxyOne = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_read_lz/findOne', params)
}
serverApi.proxySave = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_lz/save', params)
}
serverApi.proxyGradeTree = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_grade_read_lz/findTree', params)
}

serverApi.proxyListP = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_read_lz/findListP', params)
}
serverApi.proxyTree = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_read_lz/findTree', params)
}

serverApi.shippingOrderInfoSave = function(params) {
  return axios.post(api+'api/cmp.mall.Orderinfo_shipping_lz/save', params)
}

//sendCard sendStocks
serverApi.hisSendStocks = function(params) {
  return axios.post(api+'api/cmp.mall.Wxpay/sendCard', params)
}

serverApi.adUpdate = function(params) {
  return axios.post(api+'/api/cmp.mall.Ad_lz/update', params)
}
serverApi.adPositionTable = function(params) {
  return axios.post(api+'/api/cmp.mall.Ad_position_read_lz/findTable', params)
}
serverApi.shippingOrderList = function(params) {
  return axios.post(api+'api/cmp.mall.Orderinfo_shipping_read_lz/findShippingList', params)
}
serverApi.shippingListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shipping_read_lz/findListP', params)
}
serverApi.roleModuleList = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_module_read_lz/findModuleIdsList', params)
}


serverApi.cmpRoleModuleList = function(params) {
  return axios.post(api+'api/cmp.sys.Company_module_read_lz/findModuleIdsList', params)
}
serverApi.serviceTagTree = function(params) {
  return axios.post(api+'api/cmp.mall.Service_tag_Read_lz/findTree', params)
}
serverApi.uploadListP = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_read_lz/findListP', params)
}

serverApi.refundOrderinfoListP = function(params) {
  return axios.post(api+'api/cmp.mall.Orderinfo_refund_read_lz/findListP', params)
}
serverApi.shippingOrderinfoList = function(params) {
  return axios.post(api+'api/cmp.mall.Orderinfo_shipping_read_lz/findListP', params)
}
serverApi.shippingOrderInfo = function(params) {
  return axios.post(api+'api/cmp.mall.Orderinfo_shipping_read_lz/findOne', params)
}

serverApi.orderList = function(params) {
  return axios.post(api+'api/cmp.mall.Orderinfo_read_lz/findListP', params)
}
serverApi.orderInfo = function(params) {
  return axios.post(api+'api/cmp.mall.Orderinfo_read_lz/findOne', params)
}

serverApi.findOrderTreatListP = function(params) {
  return axios.post(api+'api/cmp.mall.Order_treat_read_lz/findListP', params)
}

serverApi.goodsAttributesListP = function(params) {
  return axios.post(api+'api/cmp.mall.Attributes_read_lz/findListP', params)
}
serverApi.goodsAttributesDel = function(params) {
  return axios.post(api+'api/cmp.mall.Attributes_lz/del', params)
}
serverApi.goodsAttributesList = function(params) {
  return axios.post(api+'api/cmp.mall.Attributes_read_lz/findList', params)
}
serverApi.goodsTypeTable = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_type_read_lz/findTable', params)
}
serverApi.goodsTypeTree = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_type_read_lz/findTree', params)
}
serverApi.goodsTypeSave = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_type_lz/save', params)
}

serverApi.goodsAttributesSave = function(params) {
  return axios.post(api+'api/cmp.mall.Attributes_lz/save', params)
}

serverApi.goodsAttributesValSave = function(params) {
  return axios.post(api+'api/cmp.mall.Attributes_lz/saveVal', params)
}

serverApi.goodsAttributesValDel= function(params) {
  return axios.post(api+'api/cmp.mall.Attributes_lz/delVal', params)
}
serverApi.goodsAttributesValList= function(params) {
  return axios.post(api+'api/cmp.mall.Attributes_read_lz/findValList', params)
}

serverApi.findHubListP = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_read_lz/findCarListP', params)
}

serverApi.findByShopGoodsListP = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_read_lz/findByShopListP', params)
}

serverApi.delGoods = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_lz/del', params)
}

serverApi.goodsTypeTable = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_type_read_lz/findTable', params)
}
serverApi.goodsAttrList = function(params) {
  return axios.post(api+'api/cmp.mall.Attributes_read_lz/findList', params)
}
serverApi.yhGoodsGroupListP = function(params) {
  return axios.post(api+'api/cmp.yh.Goods_group_read_lz/findListP', params)
}
serverApi.yhGoodsGroupListByShopP = function(params) {
  return axios.post(api+'api/cmp.yh.Goods_group_read_lz/findListByShopP', params)
}

serverApi.goodsCategoryTree = function(params) {
  return axios.post(api+'api/cmp.mall.Gcategory_read_lz/findTree', params)
}
serverApi.goodsSave = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_lz/save', params)
}
serverApi.goodsChange = function(params) {
  return axios.post(api+'api/cmp.mall.Goods_lz/change', params)
}
serverApi.yhOrderListP = function(params) {
  return axios.post(api+'api/cmp.yh.Order_read_lz/findListP', params)
}

serverApi.yhOrderInfo= function(params) {
  return axios.post(api+'api/cmp.yh.Order_read_lz/findOne', params)
}

serverApi.yhOrderSave = function(params) {
  return axios.post(api+'api/cmp.yh.Order_lz/save', params)
}

serverApi.yhOrderExtract = function(params) {
  return axios.post(api+'api/cmp.yh.Order_lz/extract', params)
}

serverApi.yhUserListP = function(params) {
  return axios.post(api+'api/cmp.yh.user_read_lz/findListP', params)
}
serverApi.yhUserListByShopP = function(params) {
  return axios.post(api+'api/cmp.yh.user_read_lz/findListByShopP', params)
}

serverApi.ossLocalUploadFile = function(params) {
  return axios.post(api+'api/cmp.oss.Local/uploadFile', params)
}
serverApi.findUploadForeignListP = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_read_lz/findListForeignP', params)
}

serverApi.findUploadListP = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_read_lz/findListP', params)
}

serverApi.uploadDel = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_lz/del', params)
}

//广告列表
serverApi.adListP = function(params) {
  return axios.post(api+'/api/cmp.mall.Ad_read_lz/findListP', params)
}

serverApi.adSave = function(params) {
  return axios.post(api+'/api/cmp.mall.Ad_lz/save', params)
}
serverApi.adSaveOne = function(params) {
  return axios.post(api+'/api/cmp.mall.Ad_lz/saveOne', params)
}

serverApi.findUploadGoodsForeignListP = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_read_lz/findListGoodsForeignP', params)
}

serverApi.uploadOne = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_read_lz/findOne', params)
}
serverApi.uploadSave = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_lz/save', params)
}
serverApi.uploadForeignSave = function(params) {
  return axios.post(api+'api/cmp.sys.Upload_lz/foreignSave', params)
}
serverApi.receiptSave = function(params) {
  return axios.post(api+'api/cmp.his.Receipt_lz/save', params)
}
serverApi.findReceiptListP = function(params) {
  return axios.post(api+'api/cmp.his.Receipt_read_lz/findListP', params)
}
serverApi.findPaymentListP = function(params) {
  return axios.post(api+'api/cmp.his.Payment_read_lz/findListP', params)
}
serverApi.paymentSave = function(params) {
  return axios.post(api+'api/cmp.his.Payment_lz/save', params)
}

serverApi.findAccountListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Account_read_lz/findListP', params)
}
serverApi.accountSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Account_lz/save', params)
}

serverApi.findEmployeeListP = function(params) {
  return axios.post(api+'api/cmp.oa.Employee_read_lz/findListByEngineeringP', params)
}
serverApi.findContractCategoryTable= function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_category_read_lz/findTable', params)
}
serverApi.findContractCategoryTree= function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_category_read_lz/findTree', params)
}


serverApi.findProxyGradeList = function(params) {
  return axios.post(api+'/api/cmp.proxy.Proxy_grade_read_lz/findList', params)
}

serverApi.findProxyTable = function(params) {
  return axios.post(api+'/api/cmp.proxy.Proxy_read_lz/findTable', params)
}

serverApi.findProxyListP = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_read_lz/findListP', params)
}
serverApi.constractSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_lz/save', params)
}

serverApi.findContractLogListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_log_read_lz/findListP', params)
}

serverApi.findContractPreAppprovalCategoryTable = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_pre_approval_category_read_lz/findTable', params)
}
serverApi.findContractPreAppprovalCategoryTree = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_pre_approval_category_read_lz/findTree', params)
}
serverApi.findContractPreAppprovalListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_pre_approval_read_lz/findListP', params)
}
serverApi.findContractPreAppprovalOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_pre_approval_read_lz/findOne', params)
}
serverApi.contractPreAppprovalSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_pre_approval_lz/save', params)
}

serverApi.findFeeListP = function(params) {
  return axios.post(api+'api/cmp.his.Fee_read_lz/findListP', params)
}

serverApi.findFeeCategoryTable = function(params) {
  return axios.post(api+'api/cmp.his.Fee_category_read_lz/findTable', params)
}

serverApi.findFeeCategoryTable = function(params) {
  return axios.post(api+'api/cmp.his.Fee_category_read_lz/findTable', params)
}
serverApi.findFeeCategoryTree = function(params) {
  return axios.post(api+'api/cmp.his.Fee_category_read_lz/findTree', params)
}

serverApi.findProductCategoryTree = function(params) {
  return axios.post(api+'api/cmp.his.Product_category_read_lz/findTree', params)
}
serverApi.findProductCategoryTable = function(params) {
  return axios.post(api+'api/cmp.his.Product_category_read_lz/findTable', params)
}
serverApi.findProductCategoryMenus = function(params) {
  return axios.post(api+'api/cmp.his.Product_category_read_lz/findMenus', params)
}
serverApi.productCategorySave = function(params) {
  return axios.post(api+'api/cmp.his.Product_category_lz/save', params)
}
serverApi.productCategoryDel = function(params) {
  return axios.post(api+'api/cmp.his.Product_category_lz/del', params)
}


serverApi.findContractListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_read_lz/findListP', params)
}
serverApi.findContractOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_read_lz/findOne', params)
}
serverApi.contractSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_lz/save', params)
}
serverApi.contractDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_lz/del', params)
}
serverApi.contractLogSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Contract_log_lz/save', params)
}

serverApi.findProjectCategoryTable = function(params) {
  return axios.post(api+'api/cmp.engineering.Project_category_read_lz/findTable', params)
}

serverApi.findProjectListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Project_read_lz/findListP', params)
}
serverApi.findProjectOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Project_read_lz/findOne', params)
}
serverApi.projectSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Project_lz/save', params)
}
serverApi.projectDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Project_lz/del', params)
}

serverApi.findProductListP = function(params) {
  return axios.post(api+'api/cmp.his.Product_read_lz/findListP', params)
}
serverApi.findProductOne = function(params) {
  return axios.post(api+'api/cmp.his.Product_read_lz/findOne', params)
}
serverApi.productSave = function(params) {
  return axios.post(api+'api/cmp.his.Product_lz/save', params)
}
serverApi.productDel = function(params) {
  return axios.post(api+'api/cmp.his.Product_lz/del', params)
}

serverApi.findServerOrderListP = function(params) {
  return axios.post(api+'api/cmp.his.Order_read_lz/findServerListP', params)
}
serverApi.findServerQueueOrderListP = function(params) {
  return axios.post(api+'api/cmp.his.Order_balance_read_lz/findServerQueueListP', params)
}

serverApi.caculateBalance = function(params) {
  return axios.post(api+'api/cmp.his.Order_balance_read_lz/caculateBalance', params)
}

serverApi.regionList = function(params) {
  return axios.post(api+'api/cmp.sys.Region_read_lz/findRegionList', params)
}

serverApi.regionChildren = function(params) {
  return axios.post(api+'api/cmp.sys.Region_read_lz/findRegionList', params)
}
serverApi.dicList = function(params) {
  return axios.post(api+'api/cmp.sys.Dic_read_lz/findTable', params)
}
serverApi.dicListByPid = function(params) {
  return axios.post(api+'api/cmp.sys.Dic_read_lz/findListByPid', params)
}
serverApi.dicTable = function(params) {
  return axios.post(api+'api/cmp.sys.Dic_read_lz/findDicTable', params)
}




serverApi.findShopCategoryTree = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_category_read_lz/findTree', params)
}

serverApi.shopList = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_read_lz/findList', params)
}
serverApi.shopAuth = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_lz/auth', params)
}
serverApi.shopSave = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_lz/save', params)
}
serverApi.shopSaveLgs = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_lz/saveLgs', params)
}
serverApi.shopOne = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_read_lz/findOne', params)
}
serverApi.shopListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_read_lz/findListP', params)
}


serverApi.searchShopListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_oil_read_lz/searchShopListP', params)
}
serverApi.findShopOne = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_oil_read_lz/findOne', params)
}
serverApi.shopByShopListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_oil_read_lz/findByShopListP', params)
}
serverApi.findShopTree = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_read_lz/findChildTree', params)
}

serverApi.findShopTree = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_read_lz/findChildTree', params)
}
serverApi.purchaserOne = function(params) {
  return axios.post(api+'api/cmp.shop.Purchaser_read_lz/findOne', params)
}
serverApi.purchaserSave = function(params) {
  return axios.post(api+'api/cmp.shop.Purchaser_lz/save', params)
}
serverApi.findPurchaserListP = function(params) {
  return axios.post(api+'api/cmp.shop.Purchaser_read_lz/findListP', params)
}
serverApi.findShopUserListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_user_read_lz/findListP', params)
}

serverApi.findShopEmployeeListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_employee_read_lz/findListP', params)
}


serverApi.constructionProjectSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_project_lz/save', params)
}
serverApi.constructionProjectDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_project_lz/del', params)
}
serverApi.constructionProjectOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_project_read_lz/findOne', params)
}
serverApi.constructionProjectList = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_project_read_lz/findList', params)
}
serverApi.constructionProjectListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_project_read_lz/findListP', params)
}


serverApi.constructionPerformanceSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_performance_lz/save', params)
}
serverApi.constructionPerformanceDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_performance_lz/del', params)
}
serverApi.constructionPerformanceOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_performance_read_lz/findOne', params)
}
serverApi.constructionPerformanceList = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_performance_read_lz/findList', params)
}
serverApi.constructionPerformanceListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_performance_read_lz/findListP', params)
}


serverApi.employeeCertificateSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Employee_certificate_lz/save', params)
}
serverApi.employeeCertificateDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Employee_certificate_lz/del', params)
}
serverApi.employeeCertificateOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Employee_certificate_read_lz/findOne', params)
}
serverApi.employeeCertificateList = function(params) {
  return axios.post(api+'api/cmp.engineering.Employee_certificate_read_lz/findList', params)
}
serverApi.employeeCertificateListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Employee_certificate_read_lz/findListP', params)
}



serverApi.constructionContractOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_contract_read_lz/findOne', params)
}
serverApi.constructionContractSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_contract_lz/save', params)
}
serverApi.constructionContractList = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_contract_read_lz/findListP', params)
}

serverApi.constructionContractDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Construction_contract_lz/del', params)
}


serverApi.agencyContractList = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_contract_read_lz/findListP', params)
}
serverApi.agencyContractSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_contract_lz/save', params)
}

serverApi.agencyContractDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_contract_lz/del', params)
}
serverApi.agencyContractOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_contract_read_lz/findOne', params)
}


serverApi.agencyProjectSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_project_lz/save', params)
}
serverApi.agencyProjectDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_project_lz/del', params)
}
serverApi.agencyProjectOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_project_read_lz/findOne', params)
}
serverApi.agencyProjectList = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_project_read_lz/findList', params)
}
serverApi.agencyProjectListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_project_read_lz/findListP', params)
}



serverApi.agencyPerformanceList = function(params) {
  return axios.post(api+'api/cmp.engineering.Agency_performance_read_lz/findListP', params)
}

serverApi.approvalFormList = function(params) {
  return axios.post(api+'api/cmp.engineering.Approval_form_read_lz/findListP', params)
}
serverApi.auditReportSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_audit_report_lz/save', params)
}
serverApi.auditReportDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_audit_report_lz/del', params)
}
serverApi.auditReportOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_audit_report_read_lz/findOne', params)
}
serverApi.auditReportListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_audit_report_read_lz/findListP', params)
}
serverApi.companyCreditSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_credit_lz/save', params)
}
serverApi.companyCreditOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_credit_read_lz/findOne', params)
}
serverApi.companyCreditList = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_credit_read_lz/findListP', params)
}


serverApi.costProjectSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_project_lz/save', params)
}
serverApi.costProjectDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_project_lz/del', params)
}
serverApi.costProjectOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_project_read_lz/findOne', params)
}
serverApi.costProjectList = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_project_read_lz/findList', params)
}
serverApi.costProjectListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_project_read_lz/findListP', params)
}

serverApi.costContractSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_contract_lz/save', params)
}
serverApi.costContractDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_contract_lz/del', params)
}
serverApi.costContractOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_contract_read_lz/findOne', params)
}
serverApi.costContractList = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_contract_read_lz/findList', params)
}
serverApi.costContractListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_contract_read_lz/findListP', params)
}



serverApi.companyHonorSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_honor_lz/save', params)
}
serverApi.companyHonorDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_honor_lz/del', params)
}
serverApi.companyHonorOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_honor_read_lz/findOne', params)
}
serverApi.companyHonorListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_honor_read_lz/findListP', params)
}

serverApi.opProjectSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_project_lz/save', params)
}
serverApi.opProjectDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_project_lz/del', params)
}
serverApi.opProjectOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_project_read_lz/findOne', params)
}
serverApi.opProjectListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_project_read_lz/findListP', params)
}

serverApi.opInSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_in_lz/save', params)
}
serverApi.opInDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_in_lz/del', params)
}
serverApi.opInOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_in_read_lz/findOne', params)
}
serverApi.opInListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_in_read_lz/findListP', params)
}

serverApi.opAccountSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_account_lz/save', params)
}
serverApi.opAccountDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_account_lz/del', params)
}
serverApi.opAccountOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_account_read_lz/findOne', params)
}
serverApi.opAccountListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Op_account_read_lz/findListP', params)
}

serverApi.financeSettlementItemSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_item_lz/save', params)
}
serverApi.financeSettlementItemDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_item_lz/del', params)
}
serverApi.financeSettlementItemOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_item_read_lz/findOne', params)
}
serverApi.financeSettlementItemListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_item_read_lz/findListP', params)
}

serverApi.companyMaterialSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_material_lz/save', params)
}
serverApi.companyMaterialDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_material_lz/del', params)
}
serverApi.companyMaterialOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_material_read_lz/findOne', params)
}
serverApi.companyMaterialListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_material_read_lz/findListP', params)
}

serverApi.companyQualificationsSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_qualifications_lz/save', params)
}
serverApi.companyQualificationsOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_qualifications_read_lz/findOne', params)
}
serverApi.companyQualificationsList = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_qualifications_read_lz/findListP', params)
}
serverApi.companyStatisticsist = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_statistics_read_lz/findListP', params)
}
serverApi.companyValueList = function(params) {
  return axios.post(api+'api/cmp.engineering.Company_value_read_lz/findListP', params)
}
serverApi.constructPerformanceList = function(params) {
  return axios.post(api+'api/cmp.engineering.Construct_performance_read_lz/findListP', params)
}
serverApi.costPerformanceList = function(params) {
  return axios.post(api+'api/cmp.engineering.Cost_performance_read_lz/findListP', params)
}

serverApi.financeInvoiceSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_invoice_lz/save', params)
}
serverApi.financeInvoiceOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_invoice_read_lz/findOne', params)
}

serverApi.financeInvoiceList = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_invoice_read_lz/findListP', params)
}
serverApi.financeSettlementList = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_read_lz/findListP', params)
}

serverApi.financeSettlementSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_lz/save', params)
}
serverApi.financeSettlementDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_lz/del', params)
}
serverApi.financeSettlementOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_read_lz/findOne', params)
}

serverApi.financeSettlementListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Finance_settlement_read_lz/findListP', params)
}

serverApi.supervisionProjectSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_project_lz/save', params)
}
serverApi.supervisiontDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_project_lz/del', params)
}
serverApi.supervisionProjectOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_project_read_lz/findOne', params)
}
serverApi.supervisionProjectList = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_project_read_lz/findList', params)
}
serverApi.supervisionProjectListP = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_project_read_lz/findListP', params)
}

serverApi.supervisionContractOne = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_contract_read_lz/findOne', params)
}
serverApi.supervisionContractSave = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_contract_lz/save', params)
}
serverApi.supervisionContractDel = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_contract_lz/del', params)
}

serverApi.supervisionContractList = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_contract_read_lz/findListP', params)
}
serverApi.supervisionPerformanceList = function(params) {
  return axios.post(api+'api/cmp.engineering.Supervision_performance_read_lz/findListP', params)
}


serverApi.approvalList = function(params) {
  return axios.post(api+'api/cmp.engineering.Approval_form_read_lz/findListP', params)
}


serverApi.getAdmin = function(params) {
  return axios.post(api+'api/cmp.sys.Company_user_read_lz/login', params)
}
serverApi.companyModuleList = function(params) {
  return axios.post(api+'api/cmp.sys.Company_module_read_lz/findUserModuleTreeVue', params)
}

serverApi.getCompanyMoudleTree = function(params) {
  return axios.post(api+'api/cmp.sys.Company_module_read_lz/findTree', params)
}

serverApi.getCompanyRoleList = function(params) {
  return axios.post(api+'api/cmp.sys.Company_role_read_lz/findListP', params)
}


serverApi.shopUserChangePsw = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_user_lz/changePassword', params)
}
serverApi.shopUserUpdate = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_user_lz/update', params)
}
serverApi.shopUserSave = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_user_lz/save', params)
}


serverApi.getShopUserLogin = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_user_read_lz/login', params)
}
serverApi.shopModuleList = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_module_read_lz/findUserModuleTreeVue', params)
}
serverApi.shopModuleSave = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_module_lz/save', params)
}

serverApi.proxyModuleSave = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_module_lz/save', params)
}




serverApi.findPosBrandList = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_brand_read_lz/findList', params)
}
serverApi.shopModuleFindTree = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_module_read_lz/findTree', params)
}

serverApi.getShopMoudleTree = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_module_read_lz/findTree', params)
}


serverApi.getProxyUserLogin = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_user_read_lz/login', params)
}

serverApi.getProxyUserListP = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_user_read_lz/findListP', params)
}



serverApi.getProxyRoleList = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_role_read_lz/findListP', params)
}



serverApi.getProxyMoudleTree = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_module_read_lz/findTree', params)
}
serverApi.proxyModuleList = function(params) {
  return axios.post(api+'api/cmp.proxy.Proxy_module_read_lz/findUserModuleTreeVue', params)
}




// 查询预约监测站列表信息
serverApi.getPinList = function(params) {
  return axios.post(api+'api/car.Pin_read_lz/findPinListP', params)
}
serverApi.getTravelList = function(params) {
  return axios.post(api+'api/car.pin_travel_read_lz/findTravelListP', params)
}
serverApi.getTravel = function(params) {
  return axios.post(api+'api/car.pin_travel_read_lz/findTravelOne', params)
}
// 查询预约车辆信息
serverApi.getCarList = function(params) {
  return axios.post(api+'api/vehicle.Car_read_lz/findListP', params)
}

serverApi.getAliJsonCmp = function(params) {
  return axios.post(api+'api/cmp.sys.Sign_lz/AliossPolicy_JSON', params)
}

serverApi.getAliJson = function(params) {
  return axios.post(api+'api/oss.Sign_lz/AliossPolicy_JSON', params)
}
// serverApi.getBaiduToken = function(params) {
//   return axios.post(api+'/api/rest/2.0/ocr/v1/vehicle_license', params)
// }

serverApi.payShopListByPayP = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_shop_read_lz/findListByPayP', params)
}

serverApi.findPaySourceParamsList = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_source_params_read_lz/findList', params)
}
serverApi.findPaySourceParamsListP = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_source_params_read_lz/findListP', params)
}
serverApi.findPaySourceParamsBalanceListP = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_source_params_read_lz/findParamsBalanceListP', params)
}

serverApi.findProxyBalanceListP = function(params) {
  return axios.post(api+'api/cmp.proxy.Balance_read_lz/findListP', params)
}
serverApi.findProxyBalanceDetailListP = function(params) {
  return axios.post(api+'api/cmp.proxy.Balance_detail_read_lz/findListP', params)
}

serverApi.findPaySourceParamsMoreList = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_source_params_more_read_lz/findList', params)
}
serverApi.posMemberLsListP = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_member_ls_read_lz/findListP', params)
}

serverApi.getPaySourceList = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_source_read_lz/findList', params)
}

serverApi.findPaySourceSelect = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_source_read_lz/findSelect', params)
}

serverApi.paySourceSaveParams= function(params) {
  return axios.post(api+'api/cmp.pay.Pay_source_lz/saveParams', params)
}

serverApi.paySourceListP = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_source_read_lz/findListP', params)
}
serverApi.findPaySourceList = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_source_read_lz/findList', params)
}

serverApi.payIcbcSaveAll = function(params) {
  return axios.post(api+'api/cmp.pay.Pay_icbc_Lz/saveAll', params)
}

serverApi.posMemberSaveNormal = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_member_lz/saveNormal', params)
}
serverApi.posMemberOne = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_member_read_lz/findOne', params)
}
serverApi.posMemberLsOne = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_member_ls_read_lz/findOne', params)
}
serverApi.getPayMerchantList = function(params) {
  return axios.post(api+'api/cmp.pay.Pos_member_read_lz/findMerchantListP', params)
}
serverApi.savePayMerchant = function(params) {
  return axios.post(pay+'mer.Merchant_lz/save', params)
}

// 菜单列表





serverApi.cmpUserList = function(params) {
  return axios.post(api+'api/cmp.sys.Company_user_read_lz/findListP', params)
}


// 角色管理--设置权限
serverApi.roleSetPower = function(params) {
  return axios.post(api+'api/cmp.sys.Company_role_lz/setPower', params)
}
// 菜单添加
serverApi.companyModuleSave = function(params) {
  return axios.post(api+'api/cmp.sys.Company_module_lz/save', params)
}

// 运输公司列表
serverApi.shipCompanyList = function(params) {
  return axios.post(api+'/api.crm.Shop_read_lz/findListP', params)
}

serverApi.shopListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shopinfo_read_lz/findListP', params)
}

// 运输公司列表--不分页
serverApi.shipCompanyNoPage = function(params) {
  return axios.post(api+'/api.crm.Shop_read_lz/list', params)
}

// 运输公司详情
serverApi.shipCompanyDetails = function(params) {
  return axios.post(api+'/api.crm.Shop_read_lz/findOne', params)
}

// 车辆列表
serverApi.carQueryList = function(params) {
  return axios.post(api+'/api.crm.Car_read_lz/findListP', params)
}
//新闻列表
serverApi.newsList = function(params) {
  return axios.post(api+'/api/cms.Knowledge_read_lz/findKlPageM', params)
}

serverApi.findNewsOne = function(params) {
  return axios.post(api+'/api/cmp.cms.Knowledge_read_lz/findOne', params)
}

serverApi.newsOne = function(params) {
  return axios.post(api+'api/cmp.cms.Knowledge_read_lz/findOne', params)
}
serverApi.newsDel = function(params) {
  return axios.post(api+'api/cmp.cms.Knowledge_lz/del', params)
}

//广告列表
serverApi.adList = function(params) {
  return axios.post(api+'api/cmp.mall.Ad_read_lz/findListP', params)
}
serverApi.adOne = function(params) {
  return axios.post(api+'api/cmp.mall.Ad_read_lz/findOne', params)
}

// 车辆添加
serverApi.carQuerySave = function(params) {
  return axios.post(api+'/api.crm.Car_lz/editInfo', params)
}

// 文章分类
serverApi.newsCatetory = function(params) {
  return axios.post(api+'api/cmp.cms.Category_read_lz/findTree', params)
}
serverApi.saveNewsCatetory = function(params) {
  return axios.post(api+'api/cmp.cms.Category_lz/save', params)
}
serverApi.newsListP = function(params) {
  return axios.post(api+'api/cmp.cms.Knowledge_read_lz/findKlPageM', params)
}
serverApi.newsSave = function(params) {
  return axios.post(api+'api/cmp.cms.Knowledge_lz/save', params)
}

// 会员列表
serverApi.userList = function(params) {
  return axios.post(api+'api/cmp.crm.User_read_lz/findListP', params)
}

// 车辆详情--主车信息
serverApi.carQueryDetails = function(params) {
  return axios.post(api+'api.crm.Car_read_lz/findOne', params)
}
serverApi.employeeList = function(params) {
  return axios.post(api+'api/cmp.oa.Employee_read_lz/findEmployeeList', params)
}
serverApi.shopEmployeeListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_employee_read_lz/findListP', params)
}
serverApi.shopEmployeeList = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_employee_read_lz/findList', params)
}
serverApi.shopRoleListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_role_read_lz/findListP', params)
}
serverApi.getShopRoleList = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_role_read_lz/findList', params)
}

serverApi.shopRoleDelModule = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_role_lz/delModule', params)
}

serverApi.shopRoleDel = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_role_lz/del', params)
}

// 角色添加
serverApi.shopRoleSetPower = function(params) {
  return axios.post(api+'/api/cmp.shop.Shop_role_lz/setPower', params)
}
serverApi.shopRoleSave = function(params) {
  return axios.post(api+'/api/cmp.shop.Shop_role_lz/save', params)
}
serverApi.shopRoleModuleList = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_module_read_lz/findModuleIdsList', params)
}

// 员工列表

// 员工列表-不分页
serverApi.employeeNoPage = function(params) {
  return axios.post(api+'/api.sys.Employee_read_lz/findListAll', params)
}

serverApi.employeeListP = function(params) {
  return axios.post(api+'api/cmp.oa.Employee_read_lz/findListP', params)
}
// 添加员工
serverApi.employeeSave = function(params) {
  return axios.post(api+'/api/cmp.oa.Employee_lz/saveNormal', params)
}

serverApi.employeeOne = function(params) {
  return axios.post(api+'/api/cmp.oa.Employee_read_lz/findOne', params)
}

// 用户列表添加/编辑
serverApi.companyUserSave = function(params) {
  return axios.post(api+'api/cmp.sys.Company_user_lz/save', params)
}


// 用户列表-删除
serverApi.userDel = function(params) {
  return axios.post(api+'api/cmp.sys.Company_user_lz/del', params)
}


// 用户列表-设置员工账号密码
serverApi.setUserLoginInfo = function(params) {
  return axios.post(api+'api/cmp.sys.Company_user_lz/setUserLoginInfo', params)
}

// 用户列表-员工修改账号密码
serverApi.changePassword = function(params) {
  return axios.post(api+'api/cmp.sys.Company_user_lz/changePassword', params)
}

// 用户列表-员工状态修改
serverApi.cmpUserChangeStatus = function(params) {
  return axios.post(api+'api/cmp.sys.Company_user_lz/changeStatus', params)
}


// 部门列表
serverApi.shopDepartmentList = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_department_read_lz/findListP', params)
}
serverApi.shopFindDepartmentTable = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_department_read_lz/findTable', params)
}
// 获取部门
serverApi.shopFindTree = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_department_read_lz/findChildrenList', params)
}

serverApi.getShopUserListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_user_read_lz/findListP', params)
}
serverApi.getShopUserBySchoolListP = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_user_read_lz/findBySchoolListP', params)
}

// 部门列表
serverApi.departmentList = function(params) {
  return axios.post(api+'api/cmp.oa.Department_read_lz/findListP', params)
}
serverApi.findDepartmentTable = function(params) {
  return axios.post(api+'api/cmp.oa.Department_read_lz/findTable', params)
}

// 获取部门
serverApi.findTree = function(params) {
  return axios.post(api+'api/cmp.oa.Department_read_lz/findChildrenList', params)
}

serverApi.findDicTree = function(params) {
  return axios.post(api+'api/cmp.sys.Dic_read_lz/findTree', params)
}
serverApi.dicSave = function(params) {
  return axios.post(api+'api/cmp.sys.Dic_lz/save', params)
}
serverApi.dicDel = function(params) {
  return axios.post(api+'api/cmp.sys.Dic_lz/del', params)
}
serverApi.dicOne = function(params) {
  return axios.post(api+'api/cmp.sys.Dic_read_lz/findOne', params)
}
// 部门添加
serverApi.departmentSave = function(params) {
  return axios.post(api+'api/cmp.oa.Department_lz/save', params)
}

// 角色列表
serverApi.roleList = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_role_read_lz/findListP', params)
}
// 获取角色
serverApi.rolefindTree = function(params) {
  return axios.post(api+'api/cmp.shop.Shop_role_read_lz/findTree', params)
}

serverApi.cmpRoleList = function(params) {
  return axios.post(api+'api/cmp.sys.Company_role_lz/findListP', params)
}
// 角色添加
serverApi.roleSave = function(params) {
  return axios.post(api+'api/cmp.sys.Company_role_lz/save', params)
}

// 角色 -- 修改状态
serverApi.roleChangeStatus = function(params) {
  return axios.post(api+'api.sys.Company_role_lz/changeStatus', params)
}


// 角色选择更新
serverApi.roleAddModule = function(params) {
  return axios.post(api+'api.sys.Company_role_lz/addModule', params)
}


// 角色删除
serverApi.roleDelModule = function(params) {
  return axios.post(api+'api.sys.Company_role_lz/del', params)
}

//获取access_token方法
// serverApi.getTokenBaidu = function(params) {
//   return axios.get(baiduyun+'/oauth/2.0/token?grant_type=client_credentials&client_id=nGiIkgy6rmnLdHpLv93dysjC&client_secret=kN9KsZtppMq4GBfWSTuRwUtWwRoUCk5K&', params)
// }

// 百度云--行驶证识别
serverApi.ocrVehicle = function(params) {
  return axios.post(api+'api.sys.Ocr_vehicle/ocrVehicleNew', params)
}

// 阿里云--行驶证识别
serverApi.aliyunOcrVehicle = function(params) {
  return axios.post(api+'/api.sys.aliyun_ocr_vehicle/ocrVehicleNew', params)
}

// 营业执照识别
serverApi.ocrShop = function(params) {
  return axios.post(api+'/api.sys.Ocr_vehicle/ocrShop', params)
}

// 身份证识别
serverApi.ocrIDCard = function(params) {
  return axios.post(api+'/api.sys.Ocr_vehicle/ocrIDCard', params)
}

// serverApi.getXszOCRVehicleLicense = function(params) {
//   let token = sessionStorage.getItem("access_token")
//   console.log(token,99886);
//   return axios.post(baiduyun+'/rest/2.0/ocr/v1/vehicle_license?access_token='+sessionStorage.getItem("access_token"), params)
// }

// 图片识别
// serverApi.getXszOCR = function(params) {
//   let token = sessionStorage.getItem("access_token")
//   console.log(token,99886);
//   return axios.post(baiduyun+'/rest/2.0/ocr/v1/table?access_token='+sessionStorage.getItem("access_token"), params)
// }

// // 退出
// serverApi.getOutAdmin = function(params) {
//   return axios.get('/login/out', params)
// }





// 上传文件(类型：1行驶证2营业执照3身份证4保单5支付凭证6佣金凭证 8车辆绑定的商业险保单信息9运输公司绑定的投保声明信息)
serverApi.ossUploadFile = function(params) {
  return axios.post(api+'/api.sys.oss_upload/file', params)
}


// 部门管理列表 -- 树结构
serverApi.departmentTree = function(params) {
  return axios.post(api+'api/cmp.oa.Department_read_lz/findChildrenList', params)
}

// 部门管理 -- 删除
serverApi.departmentDel = function(params) {
  return axios.post(api+'api.sys.department_Lz/del', params)
}




// 订单列表---导出----数据流
serverApi.orderListExport = function(params) {
  return axios.post(api+'/api.excel.order_info_product_read_lz/orderListExport2', params)
}
serverApi.dicList = function(params) {
  return axios.post(api+'api/sys.Dic_read_lz/findTable', params)
}



//拼车----------start
serverApi.pcFinancePinList = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_pin_read_lz/findListP', params)
}
serverApi.pcFinancePinSumList = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_pin_read_lz/findListSumP', params)
}

serverApi.pcFinanceFeeList = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_fee_read_lz/findListP', params)
}
serverApi.pcFinanceInFeeList = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_fee_read_lz/findListP', params)
}
serverApi.pcFinanceInFeeDetailList = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_fee_detail_read_lz/findListP', params)
}

serverApi.pcFinanceInFeeDetailSumList = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_fee_detail_read_lz/findListSumP', params)
}
serverApi.pcFinanceInFeeDetailFeeSumList = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_fee_detail_read_lz/findListFeeSumP', params)
}
serverApi.dicList = function(params) {
  return axios.post(api+'api/sys.Dic_read_lz/findTable', params)
}
serverApi.dicTable = function(params) {
  return axios.post(api+'api/sys.Dic_read_lz/findDicTable', params)
}
serverApi.pcFinanceFeeSave = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_fee_lz/save', params)
}
serverApi.pcSaveFinanceDetail = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_fee_detail_lz/save', params)
}
serverApi.pcSaveFinancePinTravel = function(params) {
  return axios.post(api+'api/pinche.finance.Finance_pin_travel_lz/save', params)
}
serverApi.pcLineDetailList = function(params) {
  return axios.post(api+'api/pinche.Line_detail_read_lz/findList', params)
}


serverApi.proxy = function(params) {
  return axios.post(api+'api/proxy.shop.Proxy_module_lz/save', params)
}

export default serverApi;
